import {
	daysToMs,
	type FetchTokenSupportingPlatformsData,
	type FetchTokenSupportingPlatformsParams
} from '@capsicum/common';
import { type DefaultError, useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { tokenSupportingPlantformApi } from '../api/api';

type UseTokenSupportingPlatformsQuery = {
	options?: Pick<
		UseQueryOptions<
			FetchTokenSupportingPlatformsData['data'],
			DefaultError,
			FetchTokenSupportingPlatformsData['data']
		>,
		'enabled'
	>;
	params?: FetchTokenSupportingPlatformsParams;
};

export const useTokenSupportingPlatformsQuery = ({ options = {}, params = {} }: UseTokenSupportingPlatformsQuery) =>
	useQuery({
		queryFn: async () => (await tokenSupportingPlantformApi).fetchTokenSupportingPlatforms(params),
		queryKey: ['tokenSupportingPlatforms', params],
		refetchInterval: daysToMs(1),
		select: res => res.data || [],
		staleTime: daysToMs(1),
		...options
	});
